import { EstadoPractica, InfoUsers, Practica } from '../store/practicas/types';
import { RouteTypes } from '../consts';

const abrirModalConst = 'Abrir modal';
const perfilesAlumno = ['111', '112', '121', '122', '123'];

const buildDetailIcon = (practice: Practica) => ({
  urlIcon: RouteTypes.DETAIL.replace(':id', String(practice?.ID_PRACTICA)),
  ariaLabelIcon: abrirModalConst,
  label: practice.ID_PRACTICA,
});

const buildCommonPracticeFields = (practice: Practica) => [
  {
    text: practice.ID_CURSO,
  },
  {
    text:
      parseDate(practice.FECHA_INI_SERVICIO) +
      ' ' +
      parseTime(practice.HORA_INI_SERVICIO),
  },
  {
    text:
      parseDate(practice.FECHA_FIN_SERVICIO) +
      ' ' +
      parseTime(practice.HORA_FIN_SERVICIO),
  },
  {
    text: practice.MIN_PRACTICA,
  },
  {
    text: practice.DESC_PRACTICA,
  },
  {
    text: practice.NUM_TREN,
  },
];

const buildInstructorField = (practice: Practica) => ({
  text: practice.ID_INSTRUCTOR
    ? practice.ID_INSTRUCTOR + ' - ' + practice.NOMBRE_INSTRUCTOR
    : '',
});

const buildAlumnoFields = (practice: Practica, infoUser?: InfoUsers) => [
  {
    text: infoUser ? practice.ID_ALUMNO + '-' + infoUser['NOMBRE_USUARIO'] : '',
  },
  {
    text: infoUser ? infoUser['TIPO_IE'] : '',
  },
  {
    text: infoUser ? infoUser['TIPO_USUARIO'] : '',
  },
];

const buildStatusField = (practice: Practica) => ({
  text: parsePracticeStatus(practice.ID_EST_PRACTICA),
});

const buildAlumnoProfileRow = (practice: Practica) => [
  ...buildCommonPracticeFields(practice),
  buildInstructorField(practice),
  buildStatusField(practice),
  buildDetailIcon(practice),
];

const buildInstructorProfileRow = (practice: Practica, infoUser?: InfoUsers) => [
  ...buildCommonPracticeFields(practice),
  ...buildAlumnoFields(practice, infoUser),
  buildStatusField(practice),
  buildDetailIcon(practice),
];

const buildDefaultProfileRow = (practice: Practica, infoUser?: InfoUsers) => [
  {
    text: practice.ID_CURSO,
    urlLink: '/listado-alumnos/' + practice.ID_CURSO,
  },
  ...buildCommonPracticeFields(practice).slice(1),
  buildInstructorField(practice),
  ...buildAlumnoFields(practice, infoUser),
  buildStatusField(practice),
  buildDetailIcon(practice),
];

const buildPracticeTable = (
  practice: Practica,
  idPerfil: string,
  infoUser?: InfoUsers
) => {
  if (perfilesAlumno.includes(idPerfil)) {
    return buildAlumnoProfileRow(practice);
  }

  if (idPerfil === '211') {
    return buildInstructorProfileRow(practice, infoUser);
  }

  return buildDefaultProfileRow(practice, infoUser);
};

export const ParsePractices = (
  practicas: Practica[],
  idPerfil: string,
  infoUsers: InfoUsers[]
) =>
  practicas.map((practice: Practica, index: any) => ({
    table: [buildPracticeTable(practice, idPerfil, infoUsers[index])],
  }));

export const calculateDaysClosure = (date: any) => {
  const today = new Date().getTime();
  const diff = today - Number(date);
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export const parseDate = (date: any) => {
  // By a Date class object returns the date in format dd/mm/yyyy
  if (date === null) {
    return 'Sin fecha';
  }
  const dateParse = new Date(Number(date));
  const dateFormat = (d: Date) => {
    const day =
      d.getDate().toString().length === 1
        ? '0' + d.getDate().toString()
        : d.getDate().toString();
    const month =
      (d.getMonth() + 1).toString().length === 1
        ? '0' + (d.getMonth() + 1).toString()
        : (d.getMonth() + 1).toString();
    const year = d.getFullYear().toString();

    return day + '/' + month + '/' + year;
  };

  return dateFormat(dateParse);
};

export const parseDateTime = (date: any) => {
  // By a Date class object returns the date in format dd/mm/yyyy hh:mm
  const dateParse = new Date(Number(date));
  const dateFormat = (d: Date) => {
    const day =
      d.getDate().toString().length === 1
        ? '0' + d.getDate().toString()
        : d.getDate().toString();
    const month =
      (d.getMonth() + 1).toString().length === 1
        ? '0' + (d.getMonth() + 1).toString()
        : (d.getMonth() + 1).toString();
    const year = d.getFullYear().toString();
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');

    return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
  };

  return dateFormat(dateParse);
};

export const parsePracticeStatus = (value: string) => {
  switch (value) {
    case 'BO':
      value = 'Borrador';
      break;
    case 'PV':
      value = 'Pendiente de validar';
      break;
    case 'AN':
      value = 'Anulada';
      break;
    case 'PC':
      value = 'Pendiente de corrección';
      break;
    case 'RE':
      value = 'Reclamada';
      break;
    case 'VA':
      value = 'Validada';
      break;
  }
  return value;
};

export const parseTime = (time: string) => {
  if (time?.length === 4) {
    const hours = time.slice(0, 2);
    const minutes = time.slice(2, 4);
    return hours + ':' + minutes;
  } else {
    const hours = time?.slice(0, 1);
    const minutes = time?.slice(1, 3);
    return hours + ':' + minutes;
  }
};

export const parseEstadosPracticas = (
  estadosPractica: EstadoPractica[]
): string =>
  JSON.stringify(
    estadosPractica.map((estadoPractica: EstadoPractica) => ({
      label: estadoPractica.NOMBRE_EST_PRACTICA,
      value: estadoPractica.ID_EST_PRACTICA,
    }))
  );
